"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialDescriptions = exports.MaterialDisclaimer = exports.MaterialLabels = exports.Material = exports.Materials = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Materials = [
    'cND',
    'bulky13',
    'msw',
    'bNB',
    'bNL',
    'bNS',
    'concrete',
    'concreteWashout',
    'comix',
    'compost',
    'concreteRebar',
    'asphalt',
    'dirt',
    'sand',
    'scrap',
    'creosote',
    'asbestos',
    'asbestosNonFriable',
    'tires',
    'mattresses',
    'cardboard',
    'transportation',
    'roofing',
    'CLAY_ROOFING',
    'SLATE_ROOFING',
    'WOOD_ROOFING',
    'CONCRETE_ROOFING',
    'singleStream',
    'commingle',
    'foodWaste',
    'dryIndustrialWaste',
    'bioSolids',
    'dust',
    'fineGrainCrushedRock',
    'mediumCrushedRock',
    'coarseCrushedRock',
    'largeCrushedRock',
    'other',
];
exports.Material = typebox_1.Type.Union(exports.Materials.map((m) => typebox_1.Type.Literal(m)));
exports.MaterialLabels = {
    cND: 'Construction & Demolition',
    bulky13: 'Household Items',
    msw: 'MSW',
    bNB: 'Brush & Branch',
    bNL: 'Brush & Logs',
    bNS: 'Brush & Stumps',
    concrete: 'Clean Concrete',
    comix: 'Concrete & Brick Mix',
    compost: 'Compost',
    concreteRebar: 'Concrete With Rebar',
    concreteWashout: 'Concrete Washout',
    tires: 'Tires',
    mattresses: 'Mattresses',
    asphalt: 'Asphalt',
    dirt: 'Dirt',
    sand: 'Sand',
    scrap: 'Scrap Metal',
    creosote: 'Creosote',
    asbestos: 'Friable Asbestos',
    asbestosNonFriable: 'Non-Friable Asbestos',
    cardboard: 'Cardboard',
    transportation: 'Transportation',
    roofing: 'Asphalt Roofing',
    CLAY_ROOFING: 'Clay Roofing',
    SLATE_ROOFING: 'Slate Roofing',
    WOOD_ROOFING: 'Wood Roofing',
    CONCRETE_ROOFING: 'Concrete Roofing',
    singleStream: 'Single Stream Recycling',
    commingle: 'Commingle',
    foodWaste: 'Food Waste',
    dryIndustrialWaste: 'Industrial Waste - Dry',
    bioSolids: 'Bio Solids',
    dust: 'Dust',
    fineGrainCrushedRock: 'Fine-Grain Crushed Rock',
    mediumCrushedRock: 'Medium Crushed Rock',
    coarseCrushedRock: 'Coarse Crushed Rock',
    largeCrushedRock: 'Large Crushed Rock',
    other: 'Other',
};
exports.MaterialDisclaimer = {
    scrap: 'Please note only scrap metal can go into the dumpster, no other debris are allowed in.',
    creosote: 'Please note only creosote can go into the dumpster, no other debris are allowed in.',
    asbestos: 'Please note only asbestos may be placed into the dumpster, no other debris are allowed in. Asbestos also must be properly bagged or you must use a dumpster liner.',
    asbestosNonFriable: 'Please note only asbestos may be placed into the dumpster, no other debris are allowed in. Asbestos also must be properly bagged or you must use a dumpster liner.',
    cardboard: 'Please note only cardboard can go into the dumpster, no other debris are allowed in.',
    singleStream: 'Please note only recyclables can go into the dumpster, no other debris are allowed in.',
    dirt: 'Please note only dirt can go into the dumpster, no other debris are allowed in.',
    sand: 'Please note only sand can go into the dumpster, no other debris are allowed in.',
    asphalt: 'Please note only asphalt can go into the dumpster, no other debris are allowed in.',
    comix: 'Please note only concrete and brick can go into the dumpster, no other debris or concrete slurry are allowed in.',
    compost: 'Please note only compost can go into the dumpster, no other debris are allowed in.',
    concrete: 'Please note only concrete can go into the dumpster, no other debris or concrete slurry are allowed in.',
    concreteRebar: 'Please note only concrete can go into the dumpster, no other debris or concrete slurry are allowed in.',
    concreteWashout: '',
    bNB: 'Please note only organic yard waste can go into the dumpster, no dirt or other debris are allowed in.',
    bNL: 'Please note only organic yard waste can go into the dumpster, no dirt or other debris are allowed in.',
    bNS: 'Please note only organic yard waste can go into the dumpster, no dirt or other debris are allowed in.',
    transportation: '',
    other: '',
    bulky13: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    cND: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    msw: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    roofing: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    tires: 'Placing any material other than tires in the dumpster will result in additional charges.',
    mattresses: 'Placing any material other than mattresses in the dumpster will result in additional charges.',
    CLAY_ROOFING: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    SLATE_ROOFING: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    WOOD_ROOFING: 'If you have concrete, dirt, or brick please let us know, as putting these materials in may alter your final price.',
    CONCRETE_ROOFING: 'Please note concrete tiles should not exceed 50% of the total dumpster volume.',
    commingle: 'Please note only recyclables can go into the dumpster, no other debris are allowed in.',
    foodWaste: 'Please note only food waste can go into the dumpster, no other debris are allowed in.',
    dryIndustrialWaste: '',
    bioSolids: 'Please note manifest or paperwork must be provided for bio solids.',
    dust: 'Please note that dumpster has to be covered at all times to prevent dust from escaping.',
    fineGrainCrushedRock: 'Please note that only fine-grain crushed rock can go into the dumpster, no other debris are allowed in.',
    mediumCrushedRock: 'Please note that only medium crushed rock can go into the dumpster, no other debris are allowed in.',
    coarseCrushedRock: 'Please note that only coarse crushed rock can go into the dumpster, no other debris are allowed in.',
    largeCrushedRock: 'Please note that only large crushed rock can go into the dumpster, no other debris are allowed in.',
};
exports.MaterialDescriptions = {
    bulky13: 'Non toxic items from around your home, e.g. furniture, non-freon appliances, toys, etc.',
    cND: "Materials you'd find during renovation or new building project. Excludes the following: dirt, hazardous materials, more than 3 cubic yards of concrete or aggregates.",
    roofing: 'Asphalt roofing shingles and roofing debris.',
    asbestos: 'Only friable asbestos. Must be bagged in pre-approved bags or dumpster liner. Excludes trash and other debris.',
    asphalt: "Only asphalt you'd find from your driveway. Excludes asphalt shingles, dirt, concrete, etc.",
    asbestosNonFriable: 'Only non-friable asbestos. Must be bagged in pre-approved bags or dumpster liner. Excludes trash and other debris.',
    bNB: "Only organic material you'd find from your backyard. Excludes bamboo.",
    bNL: 'Only brush and Branches, with logs over 4 inches in diameter',
    bNS: 'ONly brush and branches, with stumps',
    cardboard: 'Only cardboard. Excludes trash, other debris, etc.',
    concrete: 'Only concrete without any rebar or mesh in it. Excludes concrete slurry, trash, dirt, asphalt, etc.',
    comix: 'Only a mix of concrete and brick. Excludes concrete slurry, trash, dirt, asphalt, etc.',
    compost: 'Only compost. Excludes trash, other debris, etc.',
    concreteRebar: 'Only a mix of concrete and rebar or mesh in it. Excludes concrete slurry, trash, dirt, asphalt, etc.',
    concreteWashout: 'A temporary containment system used to capture and collect the contaminated water and slurry from washing out concrete trucks, pumps, and chutes after completing a pour.',
    creosote: 'Only creosote material, e.g. telephone poles, railroad ties, etc. Excludes trash and other debris.',
    dirt: 'Only non contaminated dirt. Excludes rocks, gravel, trash, other debris, etc.',
    sand: 'Only sand. Excludes rocks, gravel, trash, other debris, etc.',
    msw: 'Items you would typically put into your normal trashcan',
    scrap: 'Only scrap metal. Excludes trash, dirt, concrete, other debris, etc.',
    singleStream: 'Only single stream recycling, e.g. plastic, glass, cardboard, etc. Excludes trash and other debris.',
    CLAY_ROOFING: 'Clay roofing tiles only. Excluding trash and other debris.',
    commingle: 'Only commingled recycling, e.g. plastic, glass, cardboard, etc. Excludes trash and other debris.',
    WOOD_ROOFING: 'Wood roofing tiles only. Excluding trash and other debris.',
    foodWaste: 'Only organic food waste and scraps.',
    mattresses: 'Only mattresses. No other types of debris are allowed.',
    SLATE_ROOFING: 'Slate (stone) roofing tiles only. Excluding trash and other debris.',
    CONCRETE_ROOFING: 'Concrete tiles only. Excluding trash and other debris.',
    tires: 'Only tires (car, truck, etc). No other types of debris are allowed.',
    transportation: 'Only transportation of materials. No disposal.',
    dryIndustrialWaste: 'Only dry industrial waste. No other types of debris are allowed.',
    bioSolids: 'Only bio solids. No other types of debris are allowed.',
    dust: 'Only dust. No other types of debris are allowed.',
    fineGrainCrushedRock: 'Small-sized crushed rocks commonly used for base layers in paving and filling voids. Category includes RC Screenings and RC #10.',
    mediumCrushedRock: 'Medium-sized crushed rocks commonly used for structural support, moderate drainage, and landscaping projects. Category includes RC #3, RC #5, and RC #8.',
    coarseCrushedRock: 'Large crushed rocks commonly used in driveways, pathways, and construction projects. Category includes RC #57 and RC #67.',
    largeCrushedRock: 'Very large crushed rocks commonly used for heavy-duty applications such as erosion control and large-scale foundation support. Category includes RC #1.',
    other: 'Anything not listed above. If you have a mix of household items and construction materials, please select Construction & Demolition',
};
//# sourceMappingURL=materials.js.map